import { Chip } from '@mui/material';
import type { NodeClaimStatus } from './types';

const styles: Record<NodeClaimStatus, { color: 'success' | 'error' | 'warning' | 'default'; label: string }> = {
    Armed: { color: 'warning', label: 'Armed — awaiting card' },
    Claimed: { color: 'success', label: 'Claimed' },
    Expired: { color: 'default', label: 'Expired' },
    Revoked: { color: 'error', label: 'Revoked' },
};

export const StatusChip = ({ status }: { status?: NodeClaimStatus }) => {
    if (!status) return null;
    const style = styles[status] ?? { color: 'default' as const, label: status };
    return <Chip label={style.label} color={style.color} size="small" />;
};
